import { createApp } from '@app/adapters/create-app'

import ReportsGraphsList from '../screens/graphs/components/report-graphs-list'
import I18n from 'i18n-js'
import * as d3 from 'd3'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='vue-report-graphs-list']").each(function () {
    const data = this.dataset

    d3.formatDefaultLocale({
      decimal: ',',
      thousands: '.',
      grouping: [3],
      dateTime: '%a %b %e %X %Y',
      date: '%m/%d/%Y',
      time: '%H:%M:%S',
      periods: ['AM', 'PM'],
      currency: [data.currency, ' '],
    })

    d3.timeFormatDefaultLocale({
      dateTime: '%x, %X',
      date: '%-m/%-d/%Y',
      time: '%-I:%M:%S %p',
      periods: ['AM', 'PM'],
      days: I18n.t('date.day_names'),
      shortDays: I18n.t('date.abbr_day_names'),
      months: I18n.t('date.month_names').slice(1),
      shortMonths: I18n.t('date.abbr_month_names').slice(1),
    })

    createApp(ReportsGraphsList, {
      reportGraphs: JSON.parse(data.report_graphs),
    }).mount(this)
  })
})
